import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinRand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoinRand"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M9.5 16.5V7.5H10L14 16.5H14.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 11.5H7.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M16.5 11.5H14.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCoinRand;
